interface VazioQueEnsinaProps {
  explicacao: string;
  acao?: { label: string; onClick: () => void };
}

// SPEC-UX §3.9 — todo módulo vazio explica o fluxo em 2 frases e oferece a
// primeira ação real ("Nenhum blueprint publicado. Projetos nascem de
// blueprints — crie o primeiro"). Sem jargão de invariante, sem pedido de
// desculpas.
export function VazioQueEnsina({ explicacao, acao }: VazioQueEnsinaProps) {
  return (
    <div className="flex flex-col items-start gap-3 rounded-lg border border-dashed border-borda p-6">
      <p className="max-w-md text-sm text-grafite">{explicacao}</p>
      {acao && (
        <button type="button" onClick={acao.onClick} className="rounded bg-aco px-4 py-2 text-sm font-medium text-white hover:bg-aco-700">
          {acao.label}
        </button>
      )}
    </div>
  );
}
